import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {WINDOW} from '../../universal/window/window.service';

import {UserFeedback} from '../symbols/general.symbols';

import {User} from '../../auth/symbols';


@Injectable()
export class AssessmentService {

  ASSESSMENT_DATA_KEY = 'assessmentData';

  constructor(private http: HttpClient, @Inject(WINDOW) private window: Window) {
  }

  sendFeedback(feedback: UserFeedback) {
    return this.http.post<User>(`/api/user-feedback/`, feedback);
  }

  retrieveExplore() {
    return this.http.get<any>(`/api/research/subject/explore/`);
  }

  updateExplore(exploreData: any) {
    return this.http.patch<any>(`/api/research/subject/explore/`, {explore_data: exploreData});
  }

  getReservationCancelability(key: string) {
    return this.http.get<any>(`/api/mri-scheduling/cancel-reservation/${key}/`);
  }

  cancelReservation(key: string, reason: any) {
    return this.http.patch<any>(`/api/mri-scheduling/cancel-reservation/${key}/`, reason);
  }

  saveAssessmentData(assessmentInfo) {
    if (assessmentInfo && this.window.localStorage) {
      try {
        const localStorage = this.window.localStorage;
        localStorage.setItem(this.ASSESSMENT_DATA_KEY, JSON.stringify(assessmentInfo));
      } catch (error) {

      }
    }
  }

  getAssessmentData(): any {
    if (this.window.localStorage) {
      try {
        const localStorage = this.window.localStorage;
        return JSON.parse(localStorage.getItem(this.ASSESSMENT_DATA_KEY));
      } catch (error) {

      }
    }
  }
}
